import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import {
	KrDrsFakeResponsesResponseModel,
	KrDrsFakeResponsesCreateModel,
	KrDrsFakeResponsesUpdateModel,
} from 'Pages/admin'

export type KrDrsFakeResponsesState = {
	data: ResponseCatalog<KrDrsFakeResponsesResponseModel>
	requestParams: RequestParams
	chosenItem: KrDrsFakeResponsesResponseModel | null
}

const initialState: KrDrsFakeResponsesState = {
	data: new ResponseCatalog<KrDrsFakeResponsesResponseModel>(),
	requestParams: new RequestParams(),
	chosenItem: null,
}

export namespace KrDrsFakeResponsesNS {
	export type GetAll = PayloadAction<{
		params?: RequestParams
		clear?: boolean
	}>
	export type GetOne = PayloadAction<number>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type SetAll = PayloadAction<ResponseCatalog<KrDrsFakeResponsesResponseModel>>
	export type SetOne = PayloadAction<KrDrsFakeResponsesResponseModel>
	export type UpdateOne = PayloadAction<KrDrsFakeResponsesUpdateModel>
	export type CreateOne = PayloadAction<KrDrsFakeResponsesCreateModel>
	export type DeleteOne = PayloadAction<number>
}

export const krDrsFakeResponsesSlice = createSlice({
	name: 'krDrsFakeResponses',
	initialState,
	reducers: {
		getOne: (state, action: KrDrsFakeResponsesNS.GetOne) => {},
		getAll: (state, action: KrDrsFakeResponsesNS.GetAll) => {},

		setOne: (state, action: KrDrsFakeResponsesNS.SetOne) => {
			state.chosenItem = action.payload
		},
		setAll: (state, action: KrDrsFakeResponsesNS.SetAll) => {
			state.data = action.payload
		},

		clearOne: (state) => {
			state.chosenItem = null
		},
		clearAll: (state) => {
			state.data = new ResponseCatalog<KrDrsFakeResponsesResponseModel>()
			state.requestParams = new RequestParams()
			state.chosenItem = null
		},

		setRequestParams: (state, action: KrDrsFakeResponsesNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		createOne: (state, action: KrDrsFakeResponsesNS.CreateOne) => {},
		updateOne: (state, action: KrDrsFakeResponsesNS.UpdateOne) => {},
		deleteOne: (state, action: KrDrsFakeResponsesNS.DeleteOne) => {},
	},
})
